import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { AboutUsPageQuery } from 'GraphQL/DatoCMS/TypedDocuments'

import Gallery from './Gallery'
import { Container, Content } from './styles'

type Props = {
  data?: AboutUsPageQuery
  onAction?: () => void
}

function TeamMembersSection({ data, onAction }: Props) {
  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Container>
          <AppearingWrapper centered>
            <Content px={LANDING_CONTENT_PX} py={[44, 44, 80, 80, 100]}>
              <SubsectionTitle centered title="Meet Our Team" />

              <Gallery data={data} />

              <Button large onClick={onAction}>
                Join Us Today
              </Button>
            </Content>
          </AppearingWrapper>
        </Container>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default TeamMembersSection
